module.exports = __webpack_public_path__ + "img/map1.9fb97f53.jpg";